import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ApiService from "../../../Services/user/service";
import DocumentModal from "../../../components/documentModal";
import TradingViewChart from "../../../components/tradechart";
const Researchs = () => {
  const id = localStorage.getItem("parent_id");
  const currency = localStorage.getItem("currentCurrency");
  const type = currency === "1" ? "Inr" : "";
  const [researchData, setResearchData] = useState([]);
  const [showTradeModal, setShowTradeModal] = useState(false);
  const [tradeData, setTradeData] = useState(null);
    const [kycStatus, setKycStatus] = useState(0);
      const [showKycModal, setShowKycModal] = useState(false);
  const [tradeType, setTradeType] = useState("BUY");
const [lot, setLot] = useState("");
const [qty, setQty] = useState("0.00");
const [orderType, setOrderType] = useState("Market");
const [productType, setProductType] = useState("Intraday");
      
  const getUserData = async () => {
    try {
      const userid = localStorage.getItem("user_id");
      const res = await ApiService.getUserDetail(userid);

      if (res?.data?.data?.length > 0) {
        setKycStatus(res.data.data[0].kyc);
        // 0 = not done, 1 = approved, 2 = pending (example)
      }
    } catch (error) {
    }
  };


  const fetchResearches = async () => {
    try {
      const res = await ApiService.getResearch(id, type);
      setResearchData(res?.data?.data || []);
    } catch (error) {
    }
  };

  useEffect(() => {
    getUserData();
    fetchResearches();
  }, [currency]);

    const handleTradeClick = (type, item) => {
    if (kycStatus !== 1) {
      setShowKycModal(true); 
      return;
    }

    setTradeType(type);
    setTradeData(item);  
    setShowTradeModal(true);
  };


  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <div className="card-title fw-bold fs-5">Research</div>
        </div>

        <div className="card-body">
          <div className="row g-4">

            {researchData.map((item) => (
              <div className="col-md-6" key={item._id}>
                <div className="research-card">

                  {/* Coin */}
                  <h5 className="coin">{item.coin}</h5>

                  {/* Date | Status | LTP */}
                  <div className="meta">
                    <span>
                      {new Date(item.createdAt).toLocaleDateString()}
                    </span>
                    <span className={`status ${item.status.toLowerCase()}`}>
                      {item.status}
                    </span>
                    <span>LTP: {item.price}</span>
                  </div>

                  {/* SL | Entry | Target */}
                  <div className="price-line">
                    <span>SL: {item.stopLoss}</span>
                    <span>Entry: {item.price}</span>
                    <span>Target: {item.targetPrice}</span>
                  </div>

                  {/* Buy Button */}
                  {item.type === "buy" && (
                    <button
                     onClick={() => handleTradeClick("BUY", item)}
                    className="buy-btn">BUY</button>
                  )}

                </div>
              </div>
            ))}

            {researchData.length === 0 && (
              <p className="text-center text-muted">No Research Found</p>
            )}

          </div>
        </div>
      </div>



  {showTradeModal && tradeData && createPortal(
        <div 
          className="trade-panel-inline shadow-sm" 
          style={{ 
            width: "350px", 
            background: "#ffffff", 
            borderRadius: "12px", 
            border: "1px solid #eee",
            height: "calc(100vh - 160px)",
            position: "sticky",
            top: "80px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
          }}
        >
          <div className="p-3" style={{ overflowY: "auto", flex: 1 }}>

              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="m-0 text-uppercase text-info">
                  {tradeData.exch_seg}
                </h6>
                <button
                  type="button"
                  className="btn btn-sm btn-danger px-3 py-1 fw-bold text-white shadow-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowTradeModal(false);
                  }}
                  style={{ zIndex: 9999, position: "relative", pointerEvents: "auto", borderRadius: "8px" }}
                >
                  X
                </button>
              </div>


              <TradingViewChart />
              {/* SYMBOL + PRICE */}
              <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                <h5 className="fw-bold m-0">{tradeData.symbol}</h5>
                <h5 className="fw-bold text-info m-0">
                  {currency === "1" ? "₹" : "$"}{tradeData.liveprice}
                </h5>
              </div>

              {/* LOT SIZE + LOT */}
              <div className="row g-2">
                <div className="col-6">
                  <label className="small text-secondary">Lot Size</label>
                  <input
                    className="form-control border-0 text-dark"
                    style={{ background: "#f3f4f6" }}
                    value={tradeData.lotsize}
                    disabled
                  />
                </div>

                <div className="col-6">
                  <label className="small text-secondary">Lot</label>
                  <input
                    className="form-control text-dark"
                    style={{ background: "#f3f4f6", border: "1px solid #e5e7eb" }}
                    placeholder="Enter Lot"
                    value={lot}
                    onChange={(e) => {
                      const val = e.target.value;
                      setLot(val);
                      setQty(val ? Number(val).toFixed(1) : "0.00");
                    }}
                  />
                </div>
              </div>

              {/* QTY */}
              <div className="mt-3">
                <label className="small text-secondary">Buy / Sell Quantity</label>
                <input
                  className="form-control text-dark border-0"
                  style={{ background: "#f3f4f6" }}
                  value={qty}
                  disabled
                />
              </div>

              {/* ORDER TYPE */}
              <div className="d-flex gap-2 mt-3">
                {["Market", "Limit", "Stop"].map((t) => (
                  <button
                    key={t}
                    type="button"
                    className="btn w-100"
                    onClick={() => setOrderType(t)}
                    style={{
                      background: orderType === t ? "#2563eb" : "#f3f4f6",
                      border: "1px solid #e5e7eb",
                      color: orderType === t ? "#fff" : "#000",
                      borderRadius: "20px",
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>

              {/* LIMIT */}
              {orderType === "Limit" && (
                <div className="mt-3">
                  <label className="small text-secondary">Limit Price</label>
                  <input
                    className="form-control text-dark border-0"
                    style={{ background: "#f3f4f6" }}
                    placeholder="Enter Limit Price"
                  />
                </div>
              )}

              {/* STOP */}
              {orderType === "Stop" && (
                <div className="mt-3">
                  <label className="small text-secondary">Trigger Price</label>
                  <input
                    className="form-control text-dark border-0"
                    style={{ background: "#f3f4f6" }}
                    placeholder="Enter Trigger Price"
                  />
                </div>
              )}

              {/* PRODUCT TYPE */}
              <div className="d-flex gap-2 mt-3">
                {["Intraday", "Delivery"].map((p) => (
                  <button
                    key={p}
                    type="button"
                    className="btn w-100"
                    onClick={() => setProductType(p)}
                    style={{
                      background: productType === p ? "#2563eb" : "#f3f4f6",
                      border: "1px solid #e5e7eb",
                      color: productType === p ? "#fff" : "#000",
                      borderRadius: "20px",
                    }}
                  >
                    {p}
                  </button>
                ))}
              </div>

              {/* PRICE + BROKERAGE */}
              <div className="row g-2 mt-3">
                <div className="col-6">
                  <div className="p-2 rounded" style={{ background: "#f3f4f6" }}>
                    <div className="small text-secondary">Price</div>
                    <div className="text-dark">{currency === "1" ? "₹" : "$"}0</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="p-2 rounded" style={{ background: "#f3f4f6" }}>
                    <div className="small text-secondary">Brokerage</div>
                    <div className="text-dark">
                      {currency === "1" ? "₹" : "$"}{lot ? `${Number(lot).toFixed(1)} + ${Number(lot).toFixed(1)}` : "0.0 + 0.0"}
                    </div>
                  </div>
                </div>
              </div>

              {/* FUNDS */}
              <div className="row g-2 mt-3">
                <div className="col-6">
                  <div className="p-3 rounded" style={{ background: "#f3f4f6" }}>
                    <div className="text-dark small fw-bold">Required Funds</div>
                    <div className="fw-bold text-dark">{currency === "1" ? "₹" : "$"}0</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="p-3 rounded" style={{ background: "#f3f4f6" }}>
                    <div className="text-dark small fw-bold">Available Margin</div>
                    <div className="fw-bold text-dark">{currency === "1" ? "₹" : "$"}1823774534.11</div>
                  </div>
                </div>
              </div>

              {/* BUY / SELL */}
              <button
                className="btn w-100 mt-4 fw-bold py-2"
                style={{
                  background: tradeType === "BUY" ? "#16a34a" : "#dc2626",
                  color: "#fff",
                  fontSize: "18px",
                  borderRadius: "12px",
                }}
              >
                {tradeType}
              </button>

          </div>
        </div>,
        document.getElementById('right-sidebar-container') || document.body
      )}



        {showKycModal && (
        <DocumentModal
          show={showKycModal}
          onClose={() => {
            setShowKycModal(false);
            getUserData();
          }}
        />
      )}


    </div>
  );
};

export default Researchs;
